
;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Layout = APP.module('Layout');

	Layout.AccountLayout = Marionette.LayoutView.extend({
		template: JST.accountLayout,
		className: 'account-page',
		regions: {},
		initialize: function(builder){
			var accountRegions = builder.get('regions');
			var regionTpl = '';
			var regions = {};
			_.each(accountRegions, function(region){
				regionTpl += JST.accountRegion({
					regionID: region.id,
					region_name: region.name,
					region_url: region.url,
					is_external: region.is_external,
				});
				regions[region.id] = '#'+region.id;
			});

			this.setAccountTitle();

			this.template = $(this.$el).append(regionTpl);
			this.addRegions(regions);
		},

		setAccountTitle(){
			$(this.$el).prepend('<h4 class="account-title">My Account</h4>');
		}
	});

}(window, APP, Backbone, Marionette, $, _));